import { createSelector } from "reselect"
import type { OutputSelector } from "reselect"
import { getOptions } from "@kiwicom/frontend-common/services/options/reducer"
import Cookies from "js-cookie"

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mmb2BasePathSelector: OutputSelector<any, any, string> = createSelector(
  getOptions,
  (state) => state.mmb2BasePath,
)

// returns the overridden API from the URL query or from the cookie (cookie is set by the debug modal)
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const baseApiURLSelector = (state: any): string | null | undefined =>
  state.query["node_override_api*Url"] || Cookies.get("mmbApiUrl")
